module.exports = __webpack_public_path__ + "static/media/clock.6f41bdd3.png";